import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Modal, Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoMdDownload, IoIosClose } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment'
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const GoodsReceiptPage = () => {
    const fileName = 'Goods Receipt';
    const [startDate, setStartDate] = useState(new Date().setHours(0, 0, 0, 0))
    const [endDate, setEndDate] = useState(new Date().setHours(0, 0, 0, 0))
    const [goodsReceipt, setGoodsReceipt] = useState([])
    const [loading, setLoading] = useState(false)
    const [goodReceiptList, setGoodReceiptList] = useState([])
    const [modalShow, setModalShow] = useState(false)
    let filterStartDate = moment(startDate).format("L")
    let filterEndDate = moment(endDate).format("L")
    const [validated, setValidated] = useState(false)
    const [btnDisable, setBtnDisable] = useState(true)
    const [greaterErr, setGreaterErr] = useState(false)
    const [emptyErr, setEmptyErr] = useState(false)
    const [hasError, setHasError] = useState(false);
    const [goodsList, setGoodsList] = useState([])
    const submitHandler = (e) => {
        e.preventDefault()
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault()
            e.stopPropagation()
        } else {
            e.preventDefault()
            if (startDate > endDate) {
                setGreaterErr(true)
                return false
            } else if (startDate < endDate) {
                setGreaterErr(false)
            } else {
                setGreaterErr(false)
            }

            if (startDate === 0) {
                setEmptyErr(true)
                return false
            }

            filterStartDate = moment(startDate).format("L")
            filterEndDate = moment(endDate).format("L")


            getGoodsReceipts()
            setBtnDisable(true)
        }
        setValidated(true)
    }


    const columns = [
        {
            Header: "Goods Received ID  ",
            accessor: "GoodsReceivedId",
            filter: "GoodsReceivedId",
            sortType: "basic",
        },
        {
            Header: "SKU",
            accessor: "SKU",
            filter: "SKU",
            sortType: "basic",
        },
        {
            Header: "NDC",
            accessor: "NDC",
            filter: "NDC",
            sortType: "basic",
        },
        {
            Header: "Product ",
            accessor: "Product",
            filter: "Product",
            sortType: "basic",
            width: 200
        },
        {
            Header: "Goods Received quantity ",
            accessor: "GoodsReveivedQuantity",
            filter: "NDGoodsReveivedQuantityC",
            sortType: "basic",
        },
        {
            Header: "Lot number",
            accessor: "LotNumber",
            filter: "LotNumber",
            sortType: "basic",
        },
        {
            Header: "Expiration Date",
            accessor: "Expirationdate",
            filter: "Expirationdate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "Goods Receipts Cost ($)",
            accessor: "GoodsReceiptscost",
            filter: "GoodsReceiptscost",
            sortType: "basic",
        },
        {
            Header: "Goods Receipts Net Cost ($)",
            accessor: "GoodsReceiptsNetcost",
            filter: "GoodsReceiptsNetcost",
            sortType: "basic",
        },
        {
            Header: "Goods Receipts Total",
            accessor: "TotalItem",
            filter: "TotalItem",
            sortType: "basic",
        },
        {
            Header: "Created Date",
            accessor: "CreatedDate",
            filter: "CreatedDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },

    ];
    const mainGridColumns = [
        {
            Header: "Goods Received ID  ",
            accessor: "GoodsReceivedId",
            filter: "GoodsReceivedId",
            sortType: "basic",
            Cell: ({ row: { original } }) => (
                <Button variant="link" onClick={() => getChildRecords(original.GoodsReceivedId)} className="grid-action-btn">{original.GoodsReceivedId}</Button>
            )
        },
        {
            Header: "Vendor Id  ",
            accessor: "VendorId",
            filter: "VendorId",
            sortType: "basic",
        },
        {
            Header: "Vendor Name ",
            accessor: "VendorName",
            filter: "VendorName",
            sortType: "basic",
        },
        {
            Header: "Vendor Address Line1 ",
            accessor: "VendorAddressLine1",
            filter: "VendorAddressLine1",
            sortType: "basic",
            width: 180
        },
        {
            Header: "Vendor Address Line2",
            accessor: "VendorAddressLine2",
            filter: "VendorAddressLine2",
            sortType: "basic",
            width: 180
        },
        {
            Header: "Vendor City",
            accessor: "VendorCity",
            filter: "VendorCity",
            sortType: "basic",
            // width:180
        },
        {
            Header: "Vendor State ",
            accessor: "VendorState",
            filter: "VendorState",
            sortType: "basic",
        },
        {
            Header: "Vendor Zip Code ",
            accessor: "VendorZipCode",
            filter: "VendorZipCode",
            sortType: "basic",
        },
        {
            Header: "Vendor Country",
            accessor: "VendorCountry",
            filter: "VendorCountry",
            sortType: "basic",
        },
        {
            Header: "Ship From Name",
            accessor: "ShipFromName",
            filter: "ShipFromName",
            sortType: "basic",
        },
        {
            Header: "Ship From Address Line1",
            accessor: "ShipFromAddressLine1",
            filter: "ShipFromAddressLine1",
            sortType: "basic",
            width: 180
        },
        {
            Header: "Ship From Address Line2",
            accessor: "ShipFromAddressLine2",
            filter: "ShipFromAddressLine2",
            sortType: "basic",
            width: 180
        },
        {
            Header: "Ship From City",
            accessor: "ShipFromCity",
            filter: "ShipFromCity",
            sortType: "basic",
        },
        {
            Header: "Ship From State ",
            accessor: "ShipFromState",
            filter: "ShipFromState",
            sortType: "basic",
        },
        {
            Header: "Ship From Zip Code",
            accessor: "ShipFromZipCode",
            filter: "ShipFromZipCode",
            sortType: "basic",
        },
        {
            Header: "Ship From Country ",
            accessor: "ShipFromCountry",
            filter: "ShipFromCountry",
            sortType: "basic",
        },
        {
            Header: "Bill To Name",
            accessor: "BillToName",
            filter: "BillToName",
            sortType: "basic",
        },
        {
            Header: "Bill To Address Line1",
            accessor: "BillToAddressLine1",
            filter: "BillToAddressLine1",
            sortType: "basic",
        },
        {
            Header: "Bill To Address Line2",
            accessor: "BillToAddressLine2",
            filter: "BillToAddressLine2",
            sortType: "basic",
        },
        {
            Header: "Bill To City",
            accessor: "BillToCity",
            filter: "BillToCity",
            sortType: "basic",
        },
        {
            Header: "Bill To State",
            accessor: "BillToState",
            filter: "BillToState",
            sortType: "basic",
        },
        {
            Header: "Bill To Zip Code  ",
            accessor: "BillToZipCode",
            filter: "BillToZipCode",
            sortType: "basic",
        },
        {
            Header: "Bill To Country ",
            accessor: "BillToCountry",
            filter: "BillToCountry",
            sortType: "basic",
        },
        {
            Header: "Ship To Name",
            accessor: "ShipToName",
            filter: "ShipToName",
            sortType: "basic",
        },
        {
            Header: "Ship To Address Line1",
            accessor: "ShipToAddressLine1",
            filter: "ShipToAddressLine1",
            sortType: "basic",
        },
        {
            Header: "Ship To Address Line2",
            accessor: "ShipToAddressLine2",
            filter: "ShipToAddressLine2",
            sortType: "basic",
        },
        {
            Header: "Ship To City",
            accessor: "ShipToCity",
            filter: "ShipToCity",
            sortType: "basic",
        },
        {
            Header: "Ship To state",
            accessor: "ShipToState",
            filter: "ShipToState",
            sortType: "basic",
        },
        {
            Header: "Ship To Zip Code",
            accessor: "ShipToZipCode",
            filter: "ShipToZipCode",
            sortType: "basic",
        },
        {
            Header: "Ship To Country",
            accessor: "ShipToCountry",
            filter: "ShipToCountry",
            sortType: "basic",
        },
        {
            Header: "Goods Receipts Date",
            accessor: "GoodsReceiptsDate",
            filter: "GoodsReceiptsDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "Goods Receipts Status",
            accessor: "GoodsReceiptStatus",
            filter: "GoodsReceiptStatus",
            sortType: "basic",
        },
        {
            Header: "Goods Receipts Total",
            accessor: "GoodsReceiptsTotal",
            filter: "GoodsReceiptsTotal",
            sortType: "basic",
        }, {
            Header: 'Email Id',
            accessor: 'Email',
            filter: 'Email',
            sortType: 'basic',
        }, {
            Header: "Created Date",
            accessor: "CreatedDate",
            filter: "CreatedDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
    ]


    const newColumn = columns.slice(0);
    newColumn.splice(0, 1);
    const excelHeder = mainGridColumns.concat(newColumn);
    useEffect(() => {
        getGoodsReceipts()
    }, []);
    /**To get the goodsreceipts items  */
    const getChildRecords = async (id) => {
        setLoading(true)
        setModalShow(true)
        await _HttpServices
            .getData(`Api/Inbound/GoodsReceipts?_startDate=${filterStartDate}&_endDate=${filterEndDate}&Id=${id}`)
            .then((data) => {
                const result = data.data
                if (result.length > 0) {
                    result.map((res) => {
                        res.CreatedDate = moment(res.CreatedDate).format('MM/DD/YYYY');
                        res.Expirationdate = moment(res.Expirationdate).format('MM/DD/YYYY');
                        res.TotalItem = res.TotalItem == null ? "$ 0.00" : "$" + (res.TotalItem * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.GoodsReceiptscost = res.GoodsReceiptscost == null ? "$ 0.00" : "$" + (res.GoodsReceiptscost * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.GoodsReceiptsNetcost = res.GoodsReceiptsNetcost == null ? "$ 0.00" : "$" + (res.GoodsReceiptsNetcost * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                    })

                }
                setGoodReceiptList(result)
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
                setValidated(false)
            });
    }
    const handleClose = () => {
        setGoodReceiptList([])
        return setModalShow(false)
    }

    async function getGoodsReceipts() {
        setLoading(true)
        await _HttpServices
            .getData(`Api/Inbound/GoodsReceipts?_startDate=${filterStartDate}&_endDate=${filterEndDate}&Id=-1`)
            .then((data) => {
                const response = data.data

                if (response.length > 0) {
                    response.map((res) => {
                        res.GoodsReceiptsDate = moment(res.GoodsReceiptsDate).format('MM/DD/YYYY');
                        res.Expirationdate = moment(res.Expirationdate).format('MM/DD/YYYY');
                        res.CreatedDate = moment(res.CreatedDate).format('MM/DD/YYYY');
                        res.ReceivedDate = moment(res.ReceivedDate).format('MM/DD/YYYY');
                        res.GoodsReceiptscost = res.GoodsReceiptscost == null ? "$ 0.00" : "$" + (res.GoodsReceiptscost * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.GoodsReceiptsNetcost = res.GoodsReceiptsNetcost == null ? "$ 0.00" : "$" + (res.GoodsReceiptsNetcost * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.GoodsReceiptsTotal = res.GoodsReceiptsTotal == null ? "$ 0.00" : "$" + (res.GoodsReceiptsTotal * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                    })
                }
                const uniqData = Array.from(new Set(response.map(a => a.GoodsReceivedId)))
                    .map(id => {
                        return response.find(a => a.GoodsReceivedId === id)
                    })
                const goodsRecieptResult = uniqData;
                setGoodsList(response);
                setGoodsReceipt(goodsRecieptResult)
                setValidated(false)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                setValidated(false);
                setHasError(true);
            });
    }
    return (
        <section className="content">

            {/* Modal */}
            <Modal show={modalShow} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Goods Receipts List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Fragment>
                        {goodReceiptList.length > 0 ? (
                            <ReactTable columns={columns} data={goodReceiptList} />
                        ) : (
                                <div className="no-data">No data found.</div>
                            )}
                    </Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}><IoIosClose className="icon btn-icon" />Close</Button>
                </Modal.Footer>
            </Modal>
            <div className="page-title">
                <h2 className="h2">Goods Receipts</h2>
                {loading ? <Loader /> : null}
                {goodsReceipt.length > 0 ? <Button type="submit" onClick={() => getExcel(excelHeder, goodsList, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button> : null}
            </div>

            <Row>

                <Col md={12}>
                    <div className="card pt-2 mb-4">
                        <div className="card-body">
                            <Form noValidate validated={validated} onSubmit={submitHandler}>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="StartDate">
                                                    Since
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setBtnDisable(false)
                                                        return setStartDate(date)
                                                    }}
                                                    onSelect={(date) => {
                                                        setGreaterErr(false)
                                                        setBtnDisable(false)
                                                    }}
                                                    maxDate={new Date()}
                                                    required className={greaterErr ? "form-control is-invalid" : "form-control"}
                                                />
                                                {emptyErr ? <div className="err-feedback">Please select Start Date.</div> : null}
                                                {greaterErr ? <div className="err-feedback">Since should not be greater than until date.</div> : null}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="EndDate">
                                                    Until
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        setBtnDisable(false)
                                                        return setEndDate(date)
                                                    }}
                                                    onSelect={(date) => {
                                                        setBtnDisable(false)
                                                    }}
                                                    maxDate={new Date()}
                                                    required className="form-control"
                                                />
                                                <Form.Control.Feedback type="invalid">Please select End Date.</Form.Control.Feedback>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    {/* <Col md={3}>
                                        <Form.Group controlId="formLastName">
                                            <Form.Label>
                                                Vendor
                                            </Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="vendorId"
                                                type="text"
                                                // value={vendorId}
                                                onChange={e => {
                                                    setBtnDisable(false)
                                                    return setVendorId(e.target.value)
                                                }}

                                            >
                                                {vendorList.length > 0 ?
                                                    <Fragment>
                                                        {vendorList.map((vendor) => {
                                                            return <option key={vendor.Id} value={vendor.Id}>{vendor.VendorName}</option>
                                                        })}
                                                    </Fragment>
                                                    : null}
                                                ))
                                    </Form.Control>
                                        </Form.Group>
                                    </Col> */}
                                    <Col md={3}>
                                        <Form.Group className="mt-2">
                                            <Button type="submit" className="mt-3" disabled={btnDisable}>
                                                <IoMdDoneAll className="icon btn-icon" />Submit</Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>

                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                                {hasError ? <p>Error occurred. Unable to load goods receipt.</p> :
                                    <Fragment>
                                        {goodsReceipt.length > 0 ? (
                                            <ReactTable columns={mainGridColumns} data={goodsReceipt} />
                                        ) : (
                                                <div className="no-data">No data found.</div>
                                            )}
                                    </Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <Footer />
        </section>
    );
}
export default GoodsReceiptPage